module.exports = __webpack_public_path__ + "img/img_banner_project1_1.850103d9.jpg";